<template>
  <div class="pt-3">
    <h4>Beispiel</h4>
    <blockquote class="lex-entry-example mt-2">
      <Content class="exsample-content" :slice="slice"/>
    </blockquote>
  </div>
</template>

<script>
import Content from "./Content"

export default {
  name: "Example",
  components: {Content},
  props: {
    slice: Object
  }
}
</script>

<style scoped lang="scss">

blockquote.lex-entry-example {
  border-left: 2px solid #e0e2e3;
  padding: 0 20px 0;
}
</style>
